import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  hideSmall: {
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
}));

export default useStyles;
